import axios from "axios";
import { useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import useSettings from "../../hooks/useSettings";

export default function AxiosInterceptor() {
  const { logout } = useAuth();
  const { settings } = useSettings();

  useEffect(() => {
    const requestInterceptorFunction = axios.interceptors.request.use(
      (config) => {
        // eslint-disable-next-line no-param-reassign
        config.headers["client-id"] = settings.clientId;
        return config;
      },
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptorFunction);
    };
  }, [settings.clientId]);

  useEffect(() => {
    const responseInterceptorFunction = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === 401) {
          logout();
        }
        return Promise.reject(error);
      },
    );

    return () => {
      axios.interceptors.response.eject(responseInterceptorFunction);
    };
  }, [logout]);

  return null;
}
